import { render, staticRenderFns } from "./LexonSearchFieldComponent.vue?vue&type=template&id=58cbf81e&scoped=true&lang=pug"
import script from "./LexonSearchFieldComponent.vue?vue&type=script&lang=ts"
export * from "./LexonSearchFieldComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonSearchFieldComponent.vue?vue&type=style&index=0&id=58cbf81e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbf81e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58cbf81e')) {
      api.createRecord('58cbf81e', component.options)
    } else {
      api.reload('58cbf81e', component.options)
    }
    module.hot.accept("./LexonSearchFieldComponent.vue?vue&type=template&id=58cbf81e&scoped=true&lang=pug", function () {
      api.rerender('58cbf81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexonSearchField/LexonSearchFieldComponent.vue"
export default component.exports